import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    return {
        cart: cartState.value,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface EthanolCartWarningMessageStyles {
    container?: InjectableCss;
    warningMessage?: TypographyPresentationProps;
}

export const ethanolCartWarningMessageStyles: EthanolCartWarningMessageStyles = {
    container: {
        css: css`
            margin: 10px 0;
            padding: 15px;
            background-color: #f0f4f3;
            border-radius: 4px;
        `,
    },
    warningMessage: {
        color: "text",
        size: 14,
        css: css`
            display: block;
        `,
    },
};

const styles = ethanolCartWarningMessageStyles;

const EthanolCartWarningMessage: React.FC<Props> = ({ cart }) => {
    if (!cart || !cart.properties || cart.properties["containsEthanolProduct"] !== "true") {
        return null;
    }

    const warningMessage = siteMessage("EthanolCartWarning") || 
        "Due to air regulations, a product in this order can only be shipped via ground transport. Delivery may take longer than usual.";

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.warningMessage}>
                {warningMessage}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(EthanolCartWarningMessage),
    definition: {
        group: "Cart",
        icon: "exclamation-triangle",
        allowedContexts: ["CartPage", "CheckoutReviewAndSubmitPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule; 